import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSupplierRetailer } from "./SupplierRetailerContext";
import { usePageAccess } from "./PageAccessContext";

const AuthContext = createContext();

export const useAuthentication = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user_type, setUserType] = useState(null);
  const navigate = useNavigate();
  const { resetContext: resetSupplierRetailerContext } = useSupplierRetailer();
  const { resetContext: resetPageAccessContext } = usePageAccess();
  
  const signIn = (user_type = null) => {
    setIsAuthenticated(true);
    if (user_type !== null) {
      setUserType(user_type);
      localStorage.setItem("user_type", user_type);
    }
    // resetSupplierRetailerContext();//@mike
    // resetPageAccessContext();//@mike
  };

  const signOut = () => {
    setIsAuthenticated(false);
    setUserType(null);
    resetSupplierRetailerContext();
    resetPageAccessContext();
    localStorage.clear();
    navigate("/signin");
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user_type, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};